import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as moment from "moment";
import { tap, shareReplay } from 'rxjs/operators';
import { jwtDecode } from "jwt-decode";
import { AppSignalRService } from './app-signalr.service';
import { OrganizationService } from './organization.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService{

  
  constructor(
    private http: HttpClient, 
    private signalRService: AppSignalRService,
    private organizationService: OrganizationService
  ) { }

  login(username:string, password:string, apiPrefix: string = '/appapi' ) {
    return this.http.post(apiPrefix + '/user/login', {username, password}, { responseType: 'text' })
        .pipe(
          tap(res => {
            console.log('Login response', res);
            const decoded = jwtDecode(res.toString());
            console.log('Decoded token', decoded);
            this.signalRService.startConnection().subscribe(() => { console.log('SignalR connection started'); });
          }),
          shareReplay()
        );
  }
      
  logout() {
    // notify backend of logout
    const apiPrefix = this.organizationService.getApiPrefix();
    return this.http.post(apiPrefix + '/user/logout', {}, { responseType: 'text' })
    .pipe(
      tap({
        next: (res) => {
          console.log('Logout response', res);
          localStorage.removeItem("id_token"); 
          this.signalRService.stopConnection();
        },
        error: (err) => {
          console.log('Logout error', err);
          localStorage.removeItem("id_token"); 
          this.signalRService.stopConnection();
        }
      }
      ),
      shareReplay()
    );
  }

  public isAuthenticated() {
      return moment().isBefore(this.getExpiration());
  }

  getExpiration() {
      const token = localStorage.getItem("id_token") || '';
      try {

        const decoded = jwtDecode(token);
        const expiresAt = moment.unix(decoded.exp || 0);
        console.log('Expires at', expiresAt);
        return expiresAt;

      } catch { 
        console.log('Error parsing expiration');
        return moment(0);
      }
  }    
}
